import React, { useCallback, useEffect, useState } from "react";
import { CircleButton } from "_c/button";
import appShellUiVars from "_c/AppShell/ui-vars";
import AngleTopIcon from "_c/icon/AngleTop";
import { useScrollSpy } from "@/hooks/useScrollSpy";
import { scrollTo } from "@/utils/scroller";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { IS_BROWSER } from "@/misc/constants";

const VISIBLE_Y = 2000;

const StyledButton = styled(CircleButton)`
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 12;
  transition: opacity 0.3s ease;
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  @media (max-width: ${appShellUiVars.mobileBp}px) {
    right: 10px;
    bottom: ${({ isAuth }) => (isAuth ? "70px" : "10px")};
  }
`;
const ScrollFab = () => {
  const [visible, setVisible] = useState(false);
  const isAuth = useSelector(AuthSelectors.isAuth);
  const scrollPos = useScrollSpy();
  useEffect(() => {
    setVisible(scrollPos >= VISIBLE_Y);
  }, [scrollPos]);
  useEffect(() => {
    if (IS_BROWSER) {
      if (window.scrollY >= VISIBLE_Y) {
        setVisible(true);
      }
    }
  }, []);
  const scrollToTop = useCallback(() => {
    scrollTo("#search-scroll-line");
  }, []);
  return (
    <StyledButton
      large
      isVisible={visible}
      isAuth={isAuth}
      onClick={scrollToTop}
    >
      <AngleTopIcon width="20" color="white" />
    </StyledButton>
  );
};
export default ScrollFab;
